module.exports = __webpack_public_path__ + "static/media/calendar_label.99e2ef09.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/calendar_label.png
// module id = 245
// module chunks = 0